// extracted by mini-css-extract-plugin
module.exports = {"tableSection":"CampaignTargetingSelectionsDashboard_tableSection__73LbB"};